module.exports = __webpack_public_path__ + "img/annotation-dots.a3fcb8e0.svg";